module.exports = __webpack_public_path__ + "static/media/typescript.c06d3c06.svg";